var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mt-switch',{staticClass:"HmSwitch",attrs:{"activeValue":_vm.activeValue,"inactiveValue":_vm.inactiveValue},on:{"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.avalue),callback:function ($$v) {_vm.avalue=$$v},expression:"avalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }